import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import {
  postLogin,
  postJwtLogin,
} from "../../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { LOGOUT_URL } from "helpers/url_helper";


// function* loginUser({ payload: { user, history } }) {
//   try {
//     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//       const response = yield call(
//         fireBaseBackend.loginUser,
//         user.email,
//         user.password
//       );
//       yield put(loginSuccess(response));
//     } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
//       const response = yield call(postJwtLogin, {
//         email: user.email,
//         password: user.password,
//       });
//       localStorage.setItem("authUser", JSON.stringify(response));
//       yield put(loginSuccess(response));
//     } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
//       console.log("fkdfjkdjfkdjfkjd");
//       const response = yield call(postLogin, {
//         email: user.email,
//         password: user.password,
//       });
//       console.log(response, "response");
//       if (response.success) {
//         localStorage.setItem("authUser", JSON.stringify(response));
//         yield put(loginSuccess(response));
//       }
//       else {
//         yield put(apiError(response.message))
//       }
//     }
//     history('/dashboard');
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtLogin, {
        email: user.email,
        password: user.password,
      });
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      console.log("fkdfjkdjfkdjfkjd");
      const response = yield call(postLogin, {
        email: user.email,
        password: user.password,
      });
      console.log(response, "response");
      if (response?.success) {
        localStorage.setItem("authUser", JSON.stringify(response));
        yield put(loginSuccess(response));
      }
      else if (response?.message) {
        toast.error(response?.message);
        // yield put(apiError(response.message))
      }
      else {
        toast.error("something went wrong")
      }
    }
    // history('/dashboard');
  } catch (error) {
    toast.error("something went wrong")
    console.log(error)

    // yield put(apiError(error));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");


    // history('/login');
    window.location.href = LOGOUT_URL;
  } catch (error) {
    yield put(apiError(error));
  }
}



function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
